import _ from 'underscore';
import { EventType, UserEvent } from '@app/common';
import { getTimestampAsString, saveEvents } from '../DBService/DbService';

const createEvent = (userId: string | undefined, type: EventType, data?: string): UserEvent => {
    return {
        uuid: (window as any).device ? (window as any).device.uuid : 'browser',
        timestamp: getTimestampAsString(),
        type,
        data,
        initiatedBy: userId
    };
};

/**
 * - Make event saving debounced to not make db calls too often
 * - This simple eventBuffer is used to still keep all the events that are happening
 */
let eventBuffer: UserEvent[] = [];

const saveEventsFromBuffer = async () => {
    const eventsToSave = [...eventBuffer];
    eventBuffer = [];
    await saveEvents(...eventsToSave);
};

const debouncedEventSaving = _.debounce(saveEventsFromBuffer, 100);

export const createAndSaveEvent = async (userId: string | undefined, type: EventType, data?: string) => {
    eventBuffer.push(createEvent(userId, type, data));
    await debouncedEventSaving();
};